const language = {
	spanish: {
		header_title: "Adultos ",
		header_span_title: "Mayores",
		adultos_yellow_title: "ADULTOS MAYORES",
		adultos_bold_title:
			"G-Evolution permite a las familias mantener un rastreo constante de nuestros seres más queridos. Esta plataforma genera alertas basadas en el estado de la ubicación o el movimiento de la persona y/o familiar a cual se le está haciendo seguimiento.",
		adultos_bold_text:
			"Así, Foresight GPS garantiza la seguridad y bienestar de sus seres queridos con la mejor innovación tecnológica de Geolocalización y Telemática en activos y personas particulares.",
		adultos_text: [
			"A su vez, puedes disfrutar de múltiples funcionalidades para el cuidado de personas mayores y vulnerables como:",
		],
		beneficios_yellow_title: "BENEFICIOS",
		beneficio_1:
			"Tranquilidad al saber que nuestros seres más vulnerables está monitoreados 24/7",
		beneficio_2: "Asistencia ante emergencia",
		beneficio_3: "Alertas de movimientos o de ausencia de movimiento",
		beneficio_4: "Dispositivo fácil de usar",
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_list: [
			"Elegante GPS portátil de alta precisión.",
			"Batería de larga duración.",
			"Dispositivo resistente al agua (IP66).",
			"Botón de emergencia con comunicación de voz.",
			"Aviso inmediato a tus contactos de emergencia.",
			"Posibilidad de integración con centros de monitoreos y asistencia médica.",
		],
	},
	english: {
		header_title: "Elderly",
		header_span_title: "",
		adultos_yellow_title: "ELDERLY",
		adultos_bold_title:
			"G-Evolution enables families to keep track of their loved ones, our platform generates alerts based on location and movement of the individual being tracked.",
		adultos_bold_text:
			"ForesightGPS guarantees the safety and well-being of your loved ones with the best technological innovations in geolocation and telematics on individuals and assets.",
		adultos_text: [
			"You can enjoy multiple benefits for the care of the elderly and vulnerable such as:",
		],
		beneficios_yellow_title: "BENEFITS",
		beneficio_1:
			"Peace of mind knowing that your loved ones are being monitored 24/7",
		beneficio_2: "Emergency assistance ",
		beneficio_3: "Movement and absence of movement alerts",
		beneficio_4: "User friendly device",
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_list: [
			"Stylish, high-precision portable GPS.",
			"Long battery life.",
			"Waterproof device (IP66).",
			"Emergency button with verbal communication .",
			"Immediate notification to emergency contacts.",
			"Integration with monitoring centers and medical assistance.",
		],
	},
};

export default language;